import { REQUEST_METHOD } from '../../middlewares/services';

import * as types from './types';
import { endpoint } from '../../../config/const';

const list = (data) => ({
    type: types.LIST_PAYMENT,
    meta: {
        endpoint: endpoint.LIST_PAYMENT,
        method: REQUEST_METHOD.POST,
        body: data,
        hasAuth: true,
    }
});

const myPayments = () => ({
    type: types.MY_PAYMENT,
    meta: {
        endpoint: endpoint.MY_PAYMENT,
        method: REQUEST_METHOD.POST,
        body: {},
        hasAuth: true,
    }
});

const getDetail = (data) => ({
    type: types.DETAIL_PAYMENT,
    meta: {
        endpoint: endpoint.ORDER_DETAIL,
        method: REQUEST_METHOD.POST,
        body: data,
        hasAuth: true,
    }
});


const confirmBank = (data) => ({
    type: types.CONFIRM_BANK,
    meta: {
        endpoint: endpoint.CONFIRM_BANK,
        method: REQUEST_METHOD.POST,
        body: data,
        hasAuth: true,
    }
});
export default {
    list,
    getDetail,
    myPayments,
    confirmBank
}